import React from 'react'

export const InlineFormatHeader: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <div>{children}</div>
}
